'use client';
import type { NextPage } from 'next';
import { useState } from 'react';
import styles from './passenger-select.module.scss';

interface PassengerSelectProps {
  className?: string;
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  icon?: string;
}

const PassengerSelect: NextPage<PassengerSelectProps> = ({
  className = '',
  label,
  value = '',
  onChange,
  icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const passengerOptions = [
    { value: '1', label: '1 passenger' },
    { value: '2', label: '2 passengers' },
    { value: '3', label: '3 passengers' },
    { value: '4', label: '4 passengers' },
    { value: '5', label: '5 passengers' },
    { value: '6', label: '6 passengers' },
    { value: '7', label: '7 passengers' },
    { value: '8', label: '8 passengers' },
    { value: '9', label: '9 passengers' },
    { value: '10', label: '10 passengers' },
    { value: '11', label: '11 passengers' },
    { value: '12', label: '12 passengers' },
    { value: '13', label: '13 passengers' },
    { value: '14', label: '14 passengers' },
    { value: '15', label: '15 passengers' },
  ];

  const handleSelect = (optionValue: string) => {
    onChange?.(optionValue);
    setIsOpen(false);
  };

  const selectedOption = passengerOptions.find(
    (option) => option.value === value
  );
  const displayText = selectedOption?.label || 'Number of passengers';

  return (
    <div className={[styles.root, className].join(' ')}>
      {label && <label className={styles.label}>{label}</label>}
      <div className={styles.selectContainer}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        {icon && <img src={icon} alt="" className={styles.inputIcon} />}
        <div className={styles.selectField} onClick={() => setIsOpen(!isOpen)}>
          <span
            className={`${styles.selectText} ${!selectedOption ? styles.placeholder : ''}`}
          >
            {displayText}
          </span>
          <svg
            className={`${styles.chevron} ${isOpen ? styles.chevronOpen : ''}`}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M4 6L8 10L12 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {isOpen && (
          <div className={styles.dropdown}>
            {passengerOptions.map((option) => (
              <div
                key={option.value}
                className={`${styles.option} ${option.value === value ? styles.selected : ''}`}
                onClick={() => handleSelect(option.value)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PassengerSelect;
